module.exports = __webpack_public_path__ + "media/images/rests-topbar-f1d7bfbd1d3e9328eedabf8e384f6c1c.svg";